import { Button, Col, Divider, Input, InputNumber, Modal, Row, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { SwitchBlock } from "../SwitchBlock";
import { QuillEditor } from "../QuillEditor";
import OptionValuesController from "./optionValues.controller";
import { SelectEntity } from "../../helpers/select_entity/SelectEntity";
import __select from "../../helpers/select_entity/__select.controller";
import { __cpl } from "../../front/catalog/custom_product_lists/__cpl";
import i from "../../translations/i";
import PaymentGatewayController from "../../front/settings/payment/payment.gateway.controller";
import { GatewaySplitEditor, GatewaySplitRow } from "../GatewaySplitEditor";

export const Options = ({ types, options, renderTypes = [] }: any) => {
  if(renderTypes.length > 0) {
    return (
      <Row gutter={[20, 20]}>
        {types
          .filter((type: any) => renderTypes.includes(type.key))
          .map((type: any, index: number) => (
            <Option key={`option_${index}`} type={type} options={options} />
          ))}
      </Row>
    )
  } else
    return <Row gutter={[20, 20]}>{types.map((type: any, index: number) => <Option key={`option_${index}`} type={type} options={options} />)}</Row>
}

const Option = ({ type, options }: any) => {


  let element = options[type.key] ?? null

  useEffect(() => {
    switch(type.type) {
      case 'bool':
        OptionValuesController.onChangeValue(type.key, element ? element.value_int : (type.default ? type.default : false))
        break
      case 'int':
        OptionValuesController.onChangeValue(type.key, element ? element.value_int : (type.default ? type.default : 0))
        break
      case 'string':
        OptionValuesController.onChangeValue(type.key, element ? element.value_string ?? null : null)
        break
      case 'text_visual':
      case 'text':
        OptionValuesController.onChangeValue(type.key, element ? element.value_text ?? null : null)
        break
      case 'link':
        OptionValuesController.onChangeValue(type.key, normalizeRefer(element ? element.refer : null))
        break
      case 'gateway_split':
        OptionValuesController.onChangeValue(type.key, element ? element.value_text ?? null : null)
        break
    }
  }, [])

  return(
    <Col span={type.span ?? 24}>
      {type.type === 'bool' && <OptionBool type={type} options={options} value={element ? element.value_int : (type.default ? type.default : false)} />}
      {type.type === 'int' && <OptionInt type={type} value={element ? element.value_int : (type.default ? type.default : 0)} />}
      {type.type === 'string' && <OptionString type={type} value={element ? element.value_string : null} />}
      {type.type === 'text_visual' && <OptionTextVisual type={type} value={element ? element.value_text : null} />}
      {type.type === 'text' && <OptionText type={type} value={element ? element.value_text : null} />}
      {type.type === 'link' && <OptionLink type={type} refer={element ? element.refer : null} />}
      {type.type === 'gateway_split' && <OptionGatewaySplit type={type} value={element ? element.value_text : null} />}
      {type.type === 'divider' && <Divider dashed />}
      {type.type === 'title' && <TitleRender type={type}  />}
    </Col>
  )
}

const TitleRender = ({ type }: any) => <Typography.Title level={3}>{type.label}</Typography.Title>

const OptionInt = ({ type, value }: any) => {

  const [_value, setValue] = useState(value ?? false)

  return(
    <>
      <label>{type.label}</label>
      <InputNumber
        value={_value}
        onChange={(e: any) => {
          setValue(e)
          OptionValuesController.onChangeValue(type.key, e);
        }}
        style={{  width: '100%' }}
      />
    </>
  )
}

const OptionBool = ({ type, options, value }: any) => {

  const [_value, setValue] = useState(value ?? false)

  return(
    <>
      <SwitchBlock array={[
        {
          label: type.label,
          click: (e: any) => {
            setValue(e)
            OptionValuesController.onChangeValue(type.key, e)
          },
          value: _value
        },
      ]} />

      {type.depended && <><br/><Row gutter={[20, 20]}>{type.depended[0].options.map((_type: any, index: number) => <Option key={`option_${index}`} type={_type} options={options} />)}</Row></>}

      {type.depended && <Divider dashed />}
    </>
  )
}

const OptionString = ({ type, value }: any) => {

  console.log(value)

  const [_value, setValue] = useState(value ?? '')

  return(
    <>
      <label>{type.label}</label>
      <Input
        value={_value}
        onChange={e => {
          setValue(e.target.value)
          OptionValuesController.onChangeValue(type.key, e.target.value);
        }}
        style={{  width: '100%' }}
      />
    </>
  )
}

const OptionText = ({ type, value }: any) => {

  console.log('text', value)

  const [_value, setValue] = useState(value ?? null)

  return(
    <>
      <label>{type.label}</label>
      <Input.TextArea
        value={_value}
        onChange={e => {
          setValue(e.target.value)
          OptionValuesController.onChangeValue(type.key, e.target.value);
        }}
      />
    </>
  )
}

const OptionTextVisual = ({ type, value }: any) => {

  const [_value, setValue] = useState(value ?? null)

  return(
    <>
      <label>{type.label}</label>
      <QuillEditor
        value={_value}
        onChange={e => {
          setValue(e)
          OptionValuesController.onChangeValue(type.key, e);
        }}
      />
    </>
  )
}

const normalizeRefer = (refer: any): any => {
  if(!refer) return null

  // уже нормализованная форма, которую делает apply() после выбора в модалке
  if('type' in refer) return refer

  if(!refer.entity_type) return null

  return {
    type: refer.entity_type,
    value: refer.entity_id ?? refer.entity_value ?? null,
    element: null
  }
}

const OptionLink = ({ type, refer }: any) => {

  const [_refer, setRefer] = useState(() => normalizeRefer(refer))
  const [open, setOpen] = useState(false)

  const apply = () => {
    const linkType = __select.select.type

    const newValue: any = { type: linkType, value: null, element: null }

    if(linkType === 'custom_product_list') {
      newValue.value = __cpl.selectedLists[0] ?? null
      newValue.element = __cpl.list.find((el: any) => el.id === newValue.value) ?? null
    } else {
      newValue.value = __select.select.value
      newValue.element = __select.select.element
    }

    setRefer(newValue)
    OptionValuesController.onChangeValue(type.key, newValue)
    setOpen(false)
  }

  return(
    <>
      <label>{type.label}</label>
      <br/>
      <Button onClick={() => setOpen(true)}>
        {_refer && _refer.type
          ? `${__select.getTypeByCode(_refer.type)}${_refer.element ? `: ${_refer.element.name ?? _refer.element.title ?? _refer.value}` : ''}`
          : i.t('def:select')}
      </Button>

      <Modal
        title={type.label}
        open={open}
        onOk={apply}
        onCancel={() => setOpen(false)}
        destroyOnClose
        width={800}
      >
        {open &&
          <SelectEntity
            type={_refer?.type ?? ''}
            element={_refer?.value ?? ''}
            item_element={_refer?.element ?? null}
          />
        }
      </Modal>
    </>
  )
}

const parseGatewaySplitValue = (value: any): GatewaySplitRow[] => {
  if(!value) return []

  try {
    const parsed = JSON.parse(value)
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

// Правило распределения суммы (доставка/сервисный сбор/товары) между платёжными шлюзами
// ЮKassa. Хранится как JSON-строка в value_text — сериализация/десериализация тут же.
const OptionGatewaySplit = ({ type, value }: any) => {

  const [rows, setRows] = useState<GatewaySplitRow[]>(() => parseGatewaySplitValue(value))

  useEffect(() => {
    PaymentGatewayController.getList()
  }, [])

  const handleChange = (next: GatewaySplitRow[]) => {
    setRows(next)
    OptionValuesController.onChangeValue(type.key, JSON.stringify(next))
  }

  return(
    <>
      <label>{type.label}</label>
      <div style={{ marginTop: 8 }}>
        <GatewaySplitEditor rows={rows} onChange={handleChange} />
      </div>
    </>
  )
}
